import { returnPath } from "~/features/common/utils/navigation/returnPath";

export const getIndexPath = returnPath("/system/agents/timing-weather");

export const getIdPath = returnPath("/system/agents/timing-weather/:id");